export const routes = [
  {
    path: '/BomCheckList',
    name: '/BomCheckList',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/BomCheckList.vue'),
    /* no children */
  },
  {
    path: '/CalendarCode',
    name: '/CalendarCode',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/CalendarCode.vue'),
    /* no children */
  },
  {
    path: '/CaseInformation',
    name: '/CaseInformation',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/CaseInformation.vue'),
    /* no children */
  },
  {
    path: '/CollectiveVanning',
    name: '/CollectiveVanning',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/CollectiveVanning.vue'),
    /* no children */
  },
  {
    path: '/CorrespondenceCalendar',
    name: '/CorrespondenceCalendar',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/CorrespondenceCalendar.vue'),
    /* no children */
  },
  {
    path: '/DiscontinuedPart',
    name: '/DiscontinuedPart',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/DiscontinuedPart.vue'),
    /* no children */
  },
  {
    path: '/EventMaster',
    name: '/EventMaster',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/EventMaster.vue'),
    /* no children */
  },
  {
    path: '/GroupingRegistration',
    name: '/GroupingRegistration',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/GroupingRegistration.vue'),
    /* no children */
  },
  {
    path: '/Info',
    name: '/Info',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/Info.vue'),
    /* no children */
  },
  {
    path: '/JobNetKick',
    name: '/JobNetKick',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/JobNetKick.vue'),
    /* no children */
  },
  {
    path: '/LoginPage',
    name: '/LoginPage',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/LoginPage.vue'),
    /* no children */
  },
  {
    path: '/Logout',
    name: '/Logout',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/Logout.vue'),
    /* no children */
  },
  {
    path: '/OrderCompiling',
    name: '/OrderCompiling',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/OrderCompiling.vue'),
    /* no children */
  },
  {
    path: '/OrderOcfAsn',
    name: '/OrderOcfAsn',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/OrderOcfAsn.vue'),
    /* no children */
  },
  {
    path: '/OrderPlanHistory',
    name: '/OrderPlanHistory',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/OrderPlanHistory.vue'),
    /* no children */
  },
  {
    path: '/OrderVolatilitySearch',
    name: '/OrderVolatilitySearch',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/OrderVolatilitySearch.vue'),
    /* no children */
  },
  {
    path: '/PackingConditionMaintenance',
    name: '/PackingConditionMaintenance',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PackingConditionMaintenance.vue'),
    /* no children */
  },
  {
    path: '/PackingInformation',
    name: '/PackingInformation',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PackingInformation.vue'),
    /* no children */
  },
  {
    path: '/PackingPlan',
    name: '/PackingPlan',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PackingPlan.vue'),
    /* no children */
  },
  {
    path: '/PackingProgress',
    name: '/PackingProgress',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PackingProgress.vue'),
    /* no children */
  },
  {
    path: '/PackingResultsMaintenance',
    name: '/PackingResultsMaintenance',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PackingResultsMaintenance.vue'),
    /* no children */
  },
  {
    path: '/PairingRegistration',
    name: '/PairingRegistration',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PairingRegistration.vue'),
    /* no children */
  },
  {
    path: '/PartMaster',
    name: '/PartMaster',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/PartMaster.vue'),
    /* no children */
  },
  {
    path: '/ReportOutput',
    name: '/ReportOutput',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/ReportOutput.vue'),
    /* no children */
  },
  {
    path: '/SystemError',
    name: '/SystemError',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/SystemError.vue'),
    /* no children */
  },
  {
    path: '/TopPage',
    name: '/TopPage',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/TopPage.vue'),
    /* no children */
  },
  {
    path: '/WorkingCalendar',
    name: '/WorkingCalendar',
    component: () => import('/builds/globalsuzuki/p_production/prod_pxp/pkb/prod-pxp-front-end/src/pages/WorkingCalendar.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

